module.exports = __webpack_public_path__ + "img/corner-down-left.f7ddab7b.svg";